import React from 'react';
import { useWindow } from '@uds/hooks';
import { useIsVisibilitySetActive } from 'presentation/context/VisibilitySets';
import { Behavior } from 'domain/constants/callToAction';

import Tiers, { OuterProps as PureProps } from './Tiers';

interface ConnectedProps {
  selected: number;
}

interface OuterProps extends Omit<PureProps, keyof ConnectedProps> { }

const ConnectedTiers = (props: OuterProps) => {
  const window = useWindow();

  const { links = [] } = props;
  const location = window.location;
  const url = location.origin + location.pathname;
  const isVisibilitySetActive = useIsVisibilitySetActive();

  const selected = links.findIndex((link) => {
    const behavior = link.behavior;
    const goto = behavior?.type === Behavior.NAVIGATION ? behavior.goto : null;
    const visibilitySet = behavior?.type === Behavior.SET_VISIBILITY ? behavior.visibilitySet : null;
    const matchUrl = goto === location.pathname || goto === location.hash || goto === url;
    const hasVisibilitySetActive = visibilitySet != null && isVisibilitySetActive(visibilitySet);
    return matchUrl || hasVisibilitySetActive;
  });

  return <Tiers selected={selected} {...props} />;
};

export default ConnectedTiers;
